import { useQuery } from '@tanstack/react-query'
import { isEmpty } from 'lodash'
import { useParams } from 'react-router-dom'
import { fetchData } from 'src/api/api-utilities'

const fetchMessages = async (eventId) => {
  const response = await fetchData('/my_evanta/messages/', { eventId })
  if (response.status < 200 || response.status > 300) {
    const error = new Error('Error')
    error.code = response.status
    error.info = response.data
    error.text = response.statusText
    throw error
  }
  return response.data
}

const useFetchMessages = () => {
  const { eventId } = useParams()
  const { data, isLoading, refetch } = useQuery({
    queryKey: [`messages_${eventId}`],
    queryFn: () => fetchMessages(eventId),
    staleTime: Infinity,
    enabled: !!eventId,
    retry: false
  })

  const messages = isEmpty(data) ? [] : data.messages
  const messagesTimestamp = isEmpty(data) ? '' : data.meta.timestamp

  return {
    messages,
    messagesTimestamp,
    isLoadingMessages: isLoading,
    refetch
  }
}

export default useFetchMessages
